// Phase 1 validation-only chart. Registered solely outside production so the
// /_render/chart route can be exercised end-to-end (setChartExportData →
// aytm:chartReady → getChartExportPng) without any real chart-type. Renders a
// fixed 100×100 red square and rasterizes it through the shared hook.
// Spec: .aidev/tasks/headless-charts-sdk-spike/docs/tasks/01-core-infrastructure.md §6.1

import { useRef, useState, useEffect } from 'react'

import {
  svgToPngDataUrl,
  useExportableChart
} from '@aytm/app/stats/page/question-views/components/charts/lib/exportable'

const SVG_MARKUP =
  '<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100"><rect fill="red" width="100" height="100"/></svg>'

export function DummyChart() {
  const ref = useRef<HTMLDivElement>(null)
  const [ready, setReady] = useState(false)

  useEffect(() => {
    setReady(true)
  }, [])

  useExportableChart({
    deps: [ready],
    prepareForExport: async () => [await svgToPngDataUrl(SVG_MARKUP, 100, 100)]
  })

  return <div ref={ref} dangerouslySetInnerHTML={{ __html: SVG_MARKUP }} />
}
